"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIType = void 0;
var AIType;
(function (AIType) {
    AIType["BanditManchot"] = "BANDIT_MANCHOT";
    AIType["AdaptiveTest"] = "ADAPTIVE_TEST";
    AIType["CNEDAdaptiveTest"] = "CNED_ADAPTIVE_TEST";
    AIType["RevisionManager"] = "REVISION_MANAGER";
})(AIType = exports.AIType || (exports.AIType = {}));
